module.exports = __webpack_public_path__ + "img/coreintercomDesk.fff44ca6.png";